var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "布局片块标题中文",
                            prop: "titleCn",
                            rules: [
                              {
                                required: true,
                                message: "布局片块标题中文不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写布局片块标题中文" },
                            model: {
                              value: _vm.inputForm.titleCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "titleCn", $$v)
                              },
                              expression: "inputForm.titleCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "布局片块标题英文",
                            prop: "titleEn",
                            rules: [
                              {
                                required: true,
                                message: "布局片块标题英文不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写布局片块标题英文" },
                            model: {
                              value: _vm.inputForm.titleEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "titleEn", $$v)
                              },
                              expression: "inputForm.titleEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "x坐标",
                            prop: "xCoordinate",
                            rules: [
                              {
                                required: true,
                                message: "x坐标不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写x坐标" },
                            model: {
                              value: _vm.inputForm.xCoordinate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "xCoordinate", $$v)
                              },
                              expression: "inputForm.xCoordinate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "y坐标",
                            prop: "yCoordinate",
                            rules: [
                              {
                                required: true,
                                message: "y坐标不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写y坐标" },
                            model: {
                              value: _vm.inputForm.yCoordinate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "yCoordinate", $$v)
                              },
                              expression: "inputForm.yCoordinate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "布局片块图片id",
                            prop: "blockImageId",
                            rules: [
                              {
                                required: true,
                                message: "布局片块图片id不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写布局片块图片id" },
                            model: {
                              value: _vm.inputForm.blockImageId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "blockImageId", $$v)
                              },
                              expression: "inputForm.blockImageId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "布局片块描述中文",
                            prop: "descriptionCn",
                            rules: [
                              {
                                required: true,
                                message: "布局片块描述中文不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写布局片块描述中文",
                            },
                            model: {
                              value: _vm.inputForm.descriptionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionCn", $$v)
                              },
                              expression: "inputForm.descriptionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "布局片块描述英文",
                            prop: "descriptionEn",
                            rules: [
                              {
                                required: true,
                                message: "布局片块描述英文不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写布局片块描述英文",
                            },
                            model: {
                              value: _vm.inputForm.descriptionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionEn", $$v)
                              },
                              expression: "inputForm.descriptionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联产品图册id",
                            prop: "portfolioId",
                            rules: [
                              {
                                required: true,
                                message: "关联产品图册id不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联产品图册id" },
                            model: {
                              value: _vm.inputForm.portfolioId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "portfolioId", $$v)
                              },
                              expression: "inputForm.portfolioId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }